import { Fragment, useState } from 'react';
import { MetadataOverviewCard } from './MetadataOverviewCard';
import { SendToHubspotDialog } from './SendToHubspotDialog';
import { useHubspotSyncConfig } from './useHubspotSyncConfig';
export function HubspotMetadataSync() {
    const { fieldMapping, objectId, loading, error } = useHubspotSyncConfig();
    const [syncDialogOpen, setSyncDialogOpen] = useState(false);
    if (loading || error || !fieldMapping || !objectId) {
        return null;
    }
    return (<Fragment>
      <MetadataOverviewCard onOpenSyncDialog={() => setSyncDialogOpen(true)}/>
      {syncDialogOpen && (<SendToHubspotDialog fieldMapping={fieldMapping} objectId={objectId} onClose={() => setSyncDialogOpen(false)}/>)}
    </Fragment>);
}
